<section class="basket-validation-container">
  <header class="body-header">
    <span class="casto-title large" [innerHTML]="'basket.tunnel.validation.title' | translate"></span>
  </header>

  <div class="casto-card">
    <div class="content">
      <div class="products-table-container">
        <p-table [value]="items()" styleClass="casto-table products-table" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'basket.tunnel.validation.column-reference' | translate }}</th>
              <th>{{ 'basket.tunnel.validation.column-name' | translate }}</th>
              <th>{{ 'basket.tunnel.validation.column-unit-price' | translate }}</th>
              <th>{{ 'basket.tunnel.validation.column-quantity' | translate }}</th>
              <th class="align-right">{{ 'basket.tunnel.validation.column-total' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr class="product-item">
              <td class="product-ref">{{ item.product.ean }}</td>
              <td class="product-name">{{ item.product.name }}</td>
              <td class="product-price">{{ item.product.price | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
              <td class="product-quantity">{{ item.amount }}</td>
              <td class="product-total">{{ getItemTotal(item) | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr class="total-row">
              <td class="grand-total" colspan="5">
                <strong>
                  {{ 'basket.tunnel.validation.total' | translate }}
                  {{ purchaseListStore.totalListPrice() | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
                </strong>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</section>
